// eslint-disable-next-line import/prefer-default-export
export const InvestmentType = [
  { value: 'investment-team', name: 'We are an investment team' },
  { value: 'individual', name: 'Individual Investor' },
];
